export enum EFieldOperation {
  Unknown = 0,
  Create = 1,
  Update = 2,
  Delete = 3,
  Align = 4,
  Move = 5,
  TextSize = 6,
}
